module.exports = __webpack_public_path__ + "static/smoke-8c90bcb04d2e6aedd972687ea1b14d16.jpg";